import { css } from '@emotion/react';

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/field/Button';
import Icon from 'components/global/Icon';
import Typography from 'components/global/Typography';

import { faAngleDown, faAngleUp, faCircleCheck, faCircleDashed } from '@fortawesome/pro-regular-svg-icons';

import * as S from './OnboardingStep.styled';
import VideoPreviewComponent from './VideoPreviewComponent';

const OnboardingStep = ({ step, index, onboardingStepsLength, openStep, setOpenStep, fisrtNotCompletedStepIndex }) => {
	const { t } = useTranslation();

	const isClickableStep = useMemo(() => index <= fisrtNotCompletedStepIndex, [index, fisrtNotCompletedStepIndex]);

	const handleStepClick = () => {
		setOpenStep(openStep !== index ? index : fisrtNotCompletedStepIndex);
	};

	return (
		<S.StepWrapper
			isOpen={openStep === index}
			hasBorder={index !== 0 && index !== openStep + 1}
			extraPaddingBottom={index === onboardingStepsLength}
			extraPaddingTop={index === 0}
			onClick={handleStepClick}>
			<S.ProgressStep visible={openStep === index}>
				<Typography variant="caption" fontWeight="700" color="var(--content-3)" noWrap>
					{t('step').toUpperCase()} {index + 1} {t('of')} {onboardingStepsLength}
				</Typography>
			</S.ProgressStep>
			<S.AccordionHeader isClickable={isClickableStep}>
				<S.AccordionHeading>
					<S.IconWrapper>
						{step.isCompleted ? (
							<Icon icon={faCircleCheck} color="var(--blue)" size="medium" />
						) : (
							<Icon icon={faCircleDashed} color="var(--content-2)" size="medium" />
						)}
					</S.IconWrapper>
					<Typography variant="p2" fontWeight={openStep === index ? '700' : '500'} noWrap>
						{t(step.title)}
					</Typography>
					<Typography variant="p3" color="var(--content-3)" noWrap>
						({step.estimatedTime} {step.estimatedTime === '1' ? t('minute') : t('minutes')})
					</Typography>
				</S.AccordionHeading>
				<Icon
					className="expand-icon"
					icon={openStep === index ? faAngleUp : faAngleDown}
					size="medium"
					color={'var(--content-2)'}
				/>
			</S.AccordionHeader>
			{openStep === index && (
				<S.CollapseContentWrapper>
					<S.DescriptionWrapper>
						<Typography
							variant="p3"
							color="var(--content-3)"
							noWrap
							css={css`
								line-height: var(--paragraph3-line-height);
							`}>
							{t(step.description)}
						</Typography>
					</S.DescriptionWrapper>
					<S.ActionButtons>
						<div>
							<Button
								variant="blue"
								onClick={(e) => {
									step.action();
									e.stopPropagation();
								}}
								disabled={step.isCompleted}>
								{t(step.actionButtonText)}
							</Button>
						</div>
						<div>
							{step.postponeButton && (
								<Button
									variant="blueBorderless"
									onClick={step.postponeAction}
									disabled={step.isCompleted}>
									{t('postpone')}
								</Button>
							)}
						</div>
					</S.ActionButtons>
					<S.StepPreview>
						<VideoPreviewComponent fileName={step.previewFileName} />
					</S.StepPreview>
				</S.CollapseContentWrapper>
			)}
		</S.StepWrapper>
	);
};

export default OnboardingStep;
